<p-toast></p-toast>

<p-dialog [(visible)]="showDriverAddSideBar"
          [baseZIndex]="10000"
          [draggable]="false"
          [resizable]="false"
          (onHide)="cancel()"
          [style]="{width:'700px'}"
          [modal]="true">
    <ng-template pTemplate="header">
        <div style="font-weight: 700; font-size: 17px;">Add New Driver</div>
    </ng-template>
    <div>
        <div class="flex flex-row gap-4 w-full mb-4">
            <div class="flex-1 flex-col">
                <div class="input-label required">First Name</div>
                <input type="text" 
                       [(ngModel)]="driver.FirstName" 
                       placeholder="Enter Name" 
                       pInputText 
                       [ngStyle]="{'border-color': shouldShowError('firstName') ? 'red' : '#ced4da'}"
                       (blur)="onFieldBlur('firstName')"
                       (input)="onFieldInput('firstName')" />
                <div [ngClass]="{'error-message': shouldShowError('firstName')}" class="error-none">
                    <p>{{ getErrorMessage('firstName') }}</p>
                </div>
            </div>
            <div class="flex-1 flex-col">
                <div class="input-label required">Last Name</div>
                <input type="text" 
                       [(ngModel)]="driver.LastName" 
                       placeholder="Enter Name" 
                       pInputText 
                       [ngStyle]="{'border-color': shouldShowError('lastName') ? 'red' : '#ced4da'}"
                       (blur)="onFieldBlur('lastName')"
                       (input)="onFieldInput('lastName')" />
                <div [ngClass]="{'error-message': shouldShowError('lastName')}" class="error-none">
                    <p>{{ getErrorMessage('lastName') }}</p>
                </div>
            </div>
        </div>

        <div class="flex flex-row gap-4 w-full mb-4">
            <div class="flex-1 flex-col">
                <div class="input-label required">Phone Number</div>
                <div class="flex flex-row gap-3 w-full">
                    <input type="text" 
                           [(ngModel)]="driver.PhoneCountryCode" 
                           [ngStyle]="{'border-color': shouldShowError('phoneCountryCode') || driverExist ? 'red' : '#ced4da'}"
                           placeholder="+63" 
                           pInputText 
                           class="w-2" 
                           (input)="handlePhoneChanged()"
                           (blur)="onFieldBlur('phoneCountryCode')" />

                    <input type="text" 
                           [(ngModel)]="driver.PhoneBody" 
                           [ngStyle]="{'border-color': shouldShowError('phoneBody') || driverExist ? 'red' : '#ced4da'}"
                           placeholder="000 000 0000" 
                           pInputText 
                           class="flex-1" 
                           (input)="handlePhoneChanged()"
                           (blur)="onFieldBlur('phoneBody')" />
                </div>
                <div [ngClass]="{'error-message': shouldShowError('phoneCountryCode') || shouldShowError('phoneBody')}" class="error-none">
                    <p>{{ getErrorMessage('phoneCountryCode') || getErrorMessage('phoneBody') }}</p>
                </div>
                <div [ngClass]="{'error-message': driverExist}" class="error-none">
                    <p>This driver is already registered in the system.</p>
                </div>
            </div>
            <div class="flex-1 flex-col">
                <div class="input-label">Email <span style="color: #D1D5DB; ">(Optional)</span></div>
                <input type="text" 
                       [(ngModel)]="driver.Email" 
                       placeholder="Enter Email" 
                       pInputText 
                       [ngStyle]="{'border-color': shouldShowError('email') ? 'red' : '#ced4da'}"
                       (blur)="onFieldBlur('email')"
                       (input)="onFieldInput('email')" />
                <div [ngClass]="{'error-message': shouldShowError('email')}" class="error-none">
                    <p>{{ getErrorMessage('email') }}</p>
                </div>
            </div>
        </div>

        <div class="flex flex-row gap-4 w-full mb-4">
            <div class="flex-1 flex-col">
                <div class="input-label">EV Driver</div>
                <div class="flex align-items-center">
                    <p-inputSwitch [(ngModel)]="driver.IsEVDriver"></p-inputSwitch>
                    <span class="ml-2">{{ driver.IsEVDriver ? 'Yes' : 'No' }}</span>
                </div>
            </div>
        </div>

        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button class="p-button-text mr-3" [ngStyle]="{'color':'#004060'}" pButton label="Cancel" (click)="cancel()"></button>
            <button [disabled]="!driver.IsAllFieldsFilled() || driverExist || hasValidationErrors()" class="btn-default" pButton label="Create Driver" (click)="addRider()"></button>
        </div>
    </div>
</p-dialog>
